module.exports = __webpack_public_path__ + "img/swiper2_t.ef119436.png";